export enum ResetPasswordErrors {
  ExpiredTime = 'ExpiredTime',
}
